// Created common UI to be registered and work across app without to be imported.
import Vue from 'vue'

import PageTitle from './page-title/index.vue'
export { PageTitle as PageTitle }

import Block from './block'
export { Block as Block }

// export { default as Block } from "./block";

Vue.component('block', Block)
Vue.component('ui-page-title', PageTitle)
